<template>
  <div>
    <vx-card>
      <div class="flex pb-5">
        <div class="flex-1">
          {{ $t("sections.accounting.dataForm.itemCounts", { max: contracts.length }) }}
        </div>
      </div>
      <vs-table :data="contracts">
        <template slot="thead">
          <vs-th>ลำดับ</vs-th>
          <vs-th>เลขที่สัญญา</vs-th>
          <vs-th>ชื่อสัญญา</vs-th>
          <vs-th>วันที่ศาลพิพากษา</vs-th>
          <vs-th>ผลคดี</vs-th>
          <vs-th>รวมศาลพิพากษา</vs-th>
          <vs-th>สถานะการดำเนินคดี</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(row, index) in data">
            <vs-td>
              {{ index+1 }}
            </vs-td>
            <vs-td>
              <router-link :to="{ name: 'accounting-contract-detail', params: {id: row.id}}">{{ row.contractNo }}</router-link>
            </vs-td>
            <vs-td>
              {{ row.contractName }}{{ row.restructuring ? '*' : ''}}
            </vs-td>
            <vs-td>
              {{ dateOfCourtJudgment(row)  }}
            </vs-td>
            <vs-td>
              {{ prosecutionResultName(row)}}
            </vs-td>
            <vs-td>
              {{ totalAfter(row) | numberFormat }}
            </vs-td>
            <vs-td>
              {{ caseStatusName(row) }}
            </vs-td>
            <template slot="expand">
              <div class="w-full m-2 p-2">
                <b><u>รายละเอียดผลการดำเนินคดี</u></b>
                <pre>{{ prosecutionResultName(row) }}</pre><br>
                <b><u>เหตุแห่งการแพ้คดี/ชนะคดี</u></b>
                <pre>{{ prosecutionReasonDescription(row) }}</pre>
              </div>
            </template>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapNotificationActions, mapState: mapNotificationFields } = createNamespacedHelpers('Notification')

export default {
  name: 'IsRuleButNotRestructuring',
  data () {
    return {
      loading: false
    }
  },
  async created () {
    const vm = this
    await vm.getNotificationContractsIsRuledButNotRestructuring({
      action: vm.$route.params.action,
      loanDetailPlanFilter: "loanDateGteNow",
    })
  },
  computed: {
    ...mapNotificationFields(['status', 'notificationContracts']),
    contracts() {
      if (!this.notificationContracts) return [];

      return [...this.notificationContracts].sort((a, b) => {
        const dateA = a.prosecution && a.prosecution.dateOfCourtJudgment && a.prosecution.dateOfCourtJudgment !== ''
          ? new Date(a.prosecution.dateOfCourtJudgment)
          : new Date(0);

        const dateB = b.prosecution && b.prosecution.dateOfCourtJudgment && b.prosecution.dateOfCourtJudgment !== ''
          ? new Date(b.prosecution.dateOfCourtJudgment)
          : new Date(0);

        return dateA - dateB; // Ascending order (earliest first)
      });
    }
  },
  methods: {
    ...mapNotificationActions(['getNotificationContractsIsRuledButNotRestructuring']),
    dateOfCourtJudgment (row) {
      return row.prosecution.dateOfCourtJudgment
    },
    prosecutionResultName (row) {
      return row.prosecution.prosecutionResultName
    },
  prosecutionResultDescription (row) {
    return row.prosecution.prosecutionResultDescription
  },
  prosecutionReasonDescription (row) {
  return row.prosecution.prosecutionReasonDescription
  },
    totalAfter (row) {
      return row.prosecution.totalAfter
    },
    caseStatusName(row){
      return row.prosecution.caseStatusName
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>
